import { createElementVNode as _createElementVNode, createTextVNode as _createTextVNode, resolveDynamicComponent as _resolveDynamicComponent, normalizeClass as _normalizeClass, withCtx as _withCtx, openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode, resolveComponent as _resolveComponent, createVNode as _createVNode, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = { class: "product-box-wide__segment-image" }
const _hoisted_2 = ["innerHTML"]
const _hoisted_3 = {
  key: 1,
  class: "product-box-wide__product-flags"
}
const _hoisted_4 = { class: "lazy-load-image product-box-wide__image" }

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_flags = _resolveComponent("flags")!
  const _component_image_element = _resolveComponent("image-element")!

  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    (_ctx.productBoxData.personalPreferenceMessageKey)
      ? (_openBlock(), _createBlock(_resolveDynamicComponent(_ctx.getPersonalizedBannerLink() ? 'a' : 'div'), {
          key: 0,
          class: _normalizeClass(["product-box-wide__personalization-banner | personalization__banner", `personalization__banner--type_${_ctx.getPersonalPreferenceRank()}`]),
          href: _ctx.getPersonalizedBannerLink()
        }, {
          default: _withCtx(() => [
            _cache[0] || (_cache[0] = _createElementVNode("div", { class: "product-box-wide__personalization-banner-icon | personalization__banner-icon" }, null, -1 /* HOISTED */)),
            _cache[1] || (_cache[1] = _createTextVNode()),
            _createElementVNode("div", {
              class: "product-box-wide__personalization-banner-content | personalization__banner-content",
              innerHTML: _ctx.$t(_ctx.productBoxData.personalPreferenceMessageKey)
            }, null, 8 /* PROPS */, _hoisted_2)
          ]),
          _: 1 /* STABLE */
        }, 8 /* PROPS */, ["class", "href"]))
      : _createCommentVNode("v-if", true),
    _cache[2] || (_cache[2] = _createTextVNode()),
    (_ctx.productBoxData.flags)
      ? (_openBlock(), _createElementBlock("div", _hoisted_3, [
          _createVNode(_component_flags, {
            flags: _ctx.productBoxData.flags,
            limit: 3,
            "award-limit": 1,
            "white-list": _ctx.settings.flags.whitelistImage
          }, null, 8 /* PROPS */, ["flags", "white-list"])
        ]))
      : _createCommentVNode("v-if", true),
    _cache[3] || (_cache[3] = _createTextVNode()),
    (_openBlock(), _createBlock(_resolveDynamicComponent(_ctx.productBoxData.linked ? 'a' : 'div'), {
      href: _ctx.productBoxData.linked ? _ctx.productBoxData.url : null,
      class: _normalizeClass(["product-box-wide__image-wrapper", { 'product-box-wide__image-wrapper--bottle': _ctx.isBoxTypeVertical }])
    }, {
      default: _withCtx(() => [
        _createElementVNode("div", _hoisted_4, [
          _createVNode(_component_image_element, {
            "img-class": "lazy-load-image__image",
            src: _ctx.imgSrc,
            title: _ctx.productBoxData.images[1].title,
            alt: _ctx.productBoxData.images[1].alt,
            webp: true
          }, null, 8 /* PROPS */, ["src", "title", "alt"])
        ])
      ]),
      _: 1 /* STABLE */
    }, 8 /* PROPS */, ["href", "class"]))
  ]))
}